module.exports = __webpack_public_path__ + "static/img/more-icon.fe80b678.png";